import { render } from "./assessment-details.vue?vue&type=template&id=33c023c0&ts=true"
import script from "./assessment-details.vue?vue&type=script&lang=ts"
export * from "./assessment-details.vue?vue&type=script&lang=ts"

import "./assessment-details.vue?vue&type=style&index=0&id=33c023c0&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__